import { defineStore } from "pinia";
import router from "@/router";

import apiClient from "@/lib/apiClient";
import { useAlertStore } from "@/stores/alert";
import { useItemStore } from "@/stores/item";
import subscriptionService from "@/lib/subscriptionService";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: {} };

export const useAuthStore = defineStore("auth", {
  state: () => initialState,

  actions: {
    async login(credentials) {
      const res = await apiClient.login(credentials);
      if (res.status == "success") {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        this.status = { loggedIn: true };
        this.user = res.data.user;
        const itemStore = useItemStore();
        await itemStore.load();
        
        // Start subscription polling if user is on a paid plan
        subscriptionService.restartPolling(this);
        
        router.push("/");
      } else {
        const alert = useAlertStore();
        alert.error(res.message);
        this.status = {};
        this.user = {};
      }
    },

    async oAuthCallback() {
      const res = await apiClient.getActiveUser();
      if (res.status === "success") {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        this.status = { loggedIn: true };
        this.user = res.data.user;
        
        // Start subscription polling if user is on a paid plan
        subscriptionService.restartPolling(this);
      } else {
        const alert = useAlertStore();
        alert.error(res.message);
        this.status = {};
        this.user = {};
      }
    },

    async logout() {
      const res = await apiClient.logout();
      if (res.status === "success") {
        // Stop subscription polling on logout
        subscriptionService.stopPolling();
        
        localStorage.removeItem("user");
        localStorage.removeItem("items");
        this.status = {};
        this.user = {};
        router.push("/");
      }
    },

    async refresh() {
      const res = await apiClient.getActiveUser();
      if (res.status === "success") {
        this.update(res.data.user);
      }
    },

    async update(user) {
      localStorage.setItem("user", JSON.stringify(user));
      this.user = user;
      
      // Restart polling if subscription status changed
      subscriptionService.restartPolling(this);
    },

    updateSubscriptionOnly(subscription) {
      // Update only subscription without triggering polling restart
      const updatedUser = { ...this.user, subscription };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      this.user = updatedUser;
    },
  },
});
